<section class="intro-benefits-section">
  <div class="content">
    <p class="title">Beneficios</p>
    <div class="description" #animation>
      <p>- Capacitación gratuita</p>
      <p>- 100% Remoto</p>
      <p>- Estipendio durante los tres meses de pasantía al finalizar la capacitación</p>
      <p>- Trabajo asegurado con salarios competitivos al finalizar la capacitación</p>
      <p>- Crecimiento profesional en la carrera de Desarrollo de Software</p>
      <p>- Capacitarte y trabajar en un ambiente intercultural, diverso e innovador</p>
    </div>
  </div>
</section>
